module.exports = __webpack_public_path__ + "fonts/NeuePlakTextSemiBold_normal_normal.fd222f3.woff2";